// extracted by mini-css-extract-plugin
module.exports = {"pseudo-elements-screenshot":"FontAwesomeAdminView_pseudo-elements-screenshot__1M3FR","tab-header":"FontAwesomeAdminView_tab-header__1HJFu"};